export * from "./van-icon.component";
